<h2>{{temaNome}}: {{getMesStr()}}/{{ano}}</h2>
<div class="row masonry-grid" #masonryGrid>
  <div class="grid-sizer"></div> <!-- Masonry uses this to determine column width -->
  @for (materia of materias; track materia; let index = $index) {
    <div class="grid-item mb-4">
      <div class="card">
        <img src="./imagens/{{materia.data | date: 'yyyyMMdd'}}/{{materia.imagemDestaque}}" class="card-img-top"
          (error)="handleMissingImage($event)" (load)="onImageLoad()" /> <!-- Changed to onImageLoad -->
          <div class="card-body">
            <h4 class="card-title">{{materia.titulo}}</h4>
            <p class="card-text">
              <small class="text-muted">{{materia.data | date: 'dd/MM/yyyy'}}</small>
            </p>
            <p class="card-text" [innerHtml]="materia.resumo"></p>
            <div class="mt-auto">
              <a href="materia/{{materia.id}}" class="stretched-link">Continue a ler</a>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <p class="text-end"><button type="button" class="btn btn-outline-secondary mt-3 ms-3"
  (click)="backClicked()">Voltar</button></p>